export default "__VITE_ASSET__CvCngLlq__"